import React from 'react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Box from '@mui/material/Box'
import { SIGNUP_STEPS, signupPalette } from './signupTheme'

// Wizard progress for the signup flow:
// 0 Your details · 1 Choose plan · 2 Verify email · 3 Agree & pay · 4 Ready
const SignUpStepper = ({ activeStep }) => {
  return (
    <Box sx={{ width: '100%', mb: { xs: 2.5, md: 3.5 } }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          '& .MuiStepLabel-label': {
            fontSize: { xs: '0.68rem', sm: '0.8rem' },
            mt: '6px !important',
            color: 'rgba(36,47,64,0.55)',
          },
          '& .MuiStepLabel-label.Mui-active': {
            color: signupPalette.primary.main,
            fontWeight: 700,
          },
          '& .MuiStepLabel-label.Mui-completed': {
            color: signupPalette.third.dark,
            fontWeight: 600,
          },
          '& .MuiStepIcon-root': {
            color: 'rgba(36,47,64,0.18)',
          },
          '& .MuiStepIcon-root.Mui-active': {
            color: signupPalette.primary.main,
          },
          '& .MuiStepIcon-root.Mui-completed': {
            color: signupPalette.third.main,
          },
        }}
      >
        {SIGNUP_STEPS.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

export default SignUpStepper
